import Signin from "../auth/signin";
// Authentication

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/login`, Component: <Signin /> },
];
